// extracted by mini-css-extract-plugin
export default {"table":"EmailTable_table__R3peG","headerRow":"EmailTable_headerRow__J9+t-","headerCell":"EmailTable_headerCell__XTtqt","headerCellRight":"EmailTable_headerCellRight__uGBw+"};